// The server owns serial-number validation and uniqueness; the frontend only translates the
// response `type` (from setBoxSerialNumber / clearBoxSerialNumber) into a clear user message.
// Shared by the serial admin page and the Add Box flow so the wording stays in one place.
export const resolveSerialErrorMessage = (type: string | null | undefined): string => {
  switch (type) {
    case 'InvalidSerialNumber':
      return 'Not a valid serial number.'
    case 'SerialNumberAlreadyInUse':
      return 'That serial number is already assigned to another box.'
    case 'BoxDoesNotExist':
      return 'This box no longer exists — refresh the list.'
    case 'NoPermission':
      return "You don't have permission to manage serial numbers."
    default:
      return 'Something went wrong, please try again.'
  }
}
